export const COMPARISON_CONSTANTS = {
  title: "Colocation Comparison: Traditional vs OneMind",
  desc: "OneMind delivers a modern, enterprise-ready colocation experience that’s agile, transparent, and built for hybrid IT — not locked into legacy limitations.",
  items: [
    {
      title: "The Old Way",
      subTitle: "Traditional Colocation",
      points: [
        "Limited to a few regional locations",
        "Restricted ISP options, often vendor-locked",
        "Charged hourly, slow response windows",
        "Hidden costs for cross-connects, support, overages",
        "Typically long-term leases with full-rack minimums",
        "Varies by site, may require add-on audits",
        "Static environment, limited orchestration support",
        "Self-managed, minimal guidance",
      ],
    },
    {
      title: "The New Way",
      subTitle: "OneMind Colocation",
      points: [
        "Multiple geo-redundant facilities in North America, EMEA, and APAC",
        "Carrier-neutral by default, with Tier 1 upstreams and direct cloud peering",
        "24/7 included at no extra charge for common tasks (reboots, patching, cable checks)",
        "Flat-rate bundles with predictable power, bandwidth & support",
        "Per-U, half-rack, full-rack, and private cage options with short-term contracts",
        "Built-in ISO 27001, SOC 2,  PCI frameworks",
        "Compatible with hybrid cloud, SDN, and managed stack deployments",
        "Dedicated setup engineer, zero-downtime migration planning included",
      ],
    },
  ],
};
